import React from 'react';
import ReactDOM from 'react-dom';
import 'react-dates/initialize';

import drupalSettings from 'drupalSettings';
import Drupal from 'Drupal';
import { DateRangePicker } from 'react-dates';
import moment from 'moment-timezone';

class JackRabbit extends React.Component {
  constructor(props) {
    super(props);
    this.handleShow = this.handleShow.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      startDate: null,
      endDate: null,
      checkin: undefined,
      checkout: undefined,
      date: undefined,
      show: false,
      error: false,
      focusedInput: null
    };
  }

  buildUrl() {
    let JACKRABBIT_URL = 'http://discoversaintjohn.bookdirect.net/#/lodgings?campaign=SaintJohn-interior-bookingwidget&checkin=CHECKINDATE&checkout=CHECKOUTDATE&category_ids[]=103&locale=en';
    if (drupalSettings.path.currentLanguage !== 'en') {
      JACKRABBIT_URL = 'http://discoversaintjohn.bookdirect.net/#/lodgings?campaign=SaintJohn-interior-bookingwidget&checkin=CHECKINDATE&checkout=CHECKOUTDATE&category_ids[]=103&locale=fr';
    }

    if (this.state.startDate && this.state.endDate) {
      JACKRABBIT_URL = JACKRABBIT_URL.replace('CHECKINDATE', this.state.startDate.tz('America/Halifax').format('YYYYMMDD'));
      JACKRABBIT_URL = JACKRABBIT_URL.replace('CHECKOUTDATE', this.state.endDate.tz('America/Halifax').format('YYYYMMDD'));
    } else {
      JACKRABBIT_URL = JACKRABBIT_URL.replace('CHECKINDATE', moment().tz('America/Halifax').format('YYYYMMDD'));
      JACKRABBIT_URL = JACKRABBIT_URL.replace('CHECKOUTDATE', moment().add(1, 'days').tz('America/Halifax').format('YYYYMMDD'));
    }

    return JACKRABBIT_URL;
  }

  handleShow() {
    this.setState({
      show: !this.state.show,
      error: false
    })
  }

  handleSubmit(e) {
    e.preventDefault();

    return window.location = this.buildUrl();
  }
  render() {
    const smallDevice = window.matchMedia('(max-width: 600px)').matches;
    const numberOfMonths = smallDevice ? 1 : 2;
    return (
      <div id="jr-wrapper" className="jr-wrapper">
        <div id="jr-header" className="jr-header" onClick={this.handleShow}>
          <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <g id="00-Widget-Open" transform="translate(-1071.000000, -561.000000)" fill="#FFFFFF" fillRule="nonzero">
                    <g id="Group" transform="translate(1032.000000, 545.000000)">
                      <g id="Group-4-Copy">
                        <g id="calendar-check-62" transform="translate(39.000000, 16.000000)">
                          <path d="M7,16 C6.744,16 6.488,15.902 6.293,15.707 L4.293,13.707 L5.707,12.293 L7,13.586 L10.293,10.293 L11.707,11.707 L7.707,15.707 C7.512,15.902 7.256,16 7,16 Z" id="Shape"></path>
                          <path d="M15,2 L13,2 L13,0 L10,0 L10,2 L6,2 L6,0 L3,0 L3,2 L1,2 C0.448,2 0,2.448 0,3 L0,15 C0,15.552 0.448,16 1,16 L3,16 L3,14 L2,14 L2,7 L14,7 L14,14 L13,14 L13,16 L15,16 C15.552,16 16,15.552 16,15 L16,3 C16,2.448 15.552,2 15,2 Z" id="Shape"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
            </svg>

            <span id="jr-title" className="jr-title">{ (drupalSettings.path.currentLanguage == 'en') ? 'Book Now' : 'Réservez maintenant' }</span>

        </div>
        <div id="jr-body" className={"jr-body" + ((this.state.show) ? ' active' : '') }>
          <span className="jr-error" id="js-error">{(this.state.error) ? Drupal.t('Please select valid dates.') : null} </span>

          <DateRangePicker
            startDate={this.state.startDate}
            startDateId="events_start_date"
            endDate={this.state.endDate}
            endDateId="events_end_date"
            onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate, error: false })}
            focusedInput={this.state.focusedInput}
            onFocusChange={focusedInput => this.setState({ focusedInput })}
            hideKeyboardShortcutsPanel={true}
            startDatePlaceholderText={Drupal.t('Check In')}
            endDatePlaceholderText={Drupal.t('Check Out')}
            openDirection="up"
            numberOfMonths={numberOfMonths}
          />

          <a href="#" className="jr-button" id="jr-button" onClick={this.handleSubmit}>{Drupal.t('Search')}</a>
        </div>
      </div>
    )
  }
}

export default JackRabbit;
